/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует поток изменений ресурсов домена Телеметрии
 */

/**
 * Сигнал на старт генерации алертов.
 * Очередь key.telemetry_alerting.alerting_start_task
 */
export type AlertingStartTaskRequestDto = {
}
/**
 * Сигнал на старт генерации алертов.
 * Очередь key.telemetry_alerting.alerting_start_task
 */
export type AlertingStartTaskResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Сигнал на старт генерации алертов.
   * Очередь key.telemetry_alerting.alerting_start_task
   */
  "AlertingStartTask": {
    "kind": "class",
    "text": "Сигнал на старт генерации алертов.\nОчередь key.telemetry_alerting.alerting_start_task",
  },
}